  <template>
    <google-pay-button
      style="width: 100%;"
      :environment="gPayEnvironment"
      :button-type="buttonType"
      :button-color="buttonColor"
      :existing-payment-method-required="existingPaymentMethodRequired"
      :paymentRequest.prop="{
        apiVersion: paymentRequest.apiVersion,
        apiVersionMinor: paymentRequest.apiVersionMinor,
        allowedPaymentMethods: paymentRequest.allowedPaymentMethods,
        merchantInfo: paymentRequest.merchantInfo,
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPriceLabel: 'Total',
          totalPrice: formData.purchaseAmount.toString(),
          currencyCode: formData.country === 'UK' ? 'GBP' : 'EUR',
          countryCode: formData.country === 'UK' ? 'GB' : 'IE'
        },
        callbackIntents: ['PAYMENT_AUTHORIZATION']
      }"
      v-on:loadpaymentdata="onLoadPaymentData"
      :error="onError"
      v-on:click="onOpen"
      v-on:cancel="onCancel"
      :onPaymentAuthorized.prop="onPaymentDataAuthorized"
      />

  </template>
  
  <script>
  import "@google-pay/button-element";
  // GOOGLE PAY
  const { VUE_APP_GPAY_ENV, VUE_APP_GPAY_GATEWAY, VUE_APP_GPAY_GATEWAYID, VUE_APP_GPAY_MERCHANTID ,VUE_APP_GPAY_MERCHANT_NAME } = process.env
  import { createPaymentLog } from "../../services/api";
  export default {
    name: "GooglePay",
    props: {
      formData: Object
    },
    data() {
      return {
        existingPaymentMethodRequired: false,
        buttonColor: "default",
        buttonType: "pay",
        gPayEnvironment: VUE_APP_GPAY_ENV,
        paymentRequest: {
          apiVersion: 2,
          apiVersionMinor: 0,
          allowedPaymentMethods: [
            {
              type: "CARD",
              parameters: {
                allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                allowedCardNetworks: ["MASTERCARD", "VISA", "AMEX"]
              },
              tokenizationSpecification: {
                type: "PAYMENT_GATEWAY",
                parameters: {
                  gateway: VUE_APP_GPAY_GATEWAY,
                  gatewayMerchantId: VUE_APP_GPAY_GATEWAYID
                }
              }
            }
          ],
          merchantInfo: {
            merchantId: VUE_APP_GPAY_MERCHANTID,
            merchantName: VUE_APP_GPAY_MERCHANT_NAME
          }
        }
      };
    },


    methods: {
      // Runs First when button is clicked
      async onOpen(event) {
        event.preventDefault();
        const data = {
          name: `${this.formData.name} - ${this.formData.bookReference}`,
          message: "Selected Pay With Google Pay",
          content: this.formData,
          transId: 900973,
          error: false
        };
        // Save transaction to mongo where API will create a log.
        await createPaymentLog(data);
      },
      // Runs Second and is a prop
      onPaymentDataAuthorized() {
        //  if passed validation return tansactionState : success
        // Must be returned in order to continue
        return {
          transactionState: "SUCCESS"
        };
      },
      // Runs Last once payment data is returned with token
      async onLoadPaymentData(paymentData) {
        // Send to onSubmit function and pass to socket
        this.$emit("on-submit", paymentData);
      },
      async onError(reason) {
        const data = {
          name: `${this.formData.name} - ${this.formData.bookReference}`,
          message: "Error With Google Pay Prompt",
          content: reason,
          transId: 900973,
          error: true
        };
        // Save transaction to mongo where API will create a log.
        await createPaymentLog(data);
      },
      async onCancel(event) {
        // If transaction Cancelled send status to the socket and store log of the status in mongo
        const data = {
          name: `${this.formData.name} - ${this.formData.bookReference}`,
          message: "Google Pay Cancelled",
          content: event,
          transId: 900973,
          error: false
        };
        // Save transaction to mongo where API will create a log.
        await createPaymentLog(data);
      }
    },
  };
  </script>
  
  <style>
  .gpay-button{
    width: 100% !important;
  }
  .gpay-button.new_style {
    background-origin: content-box !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    border: 0px !important;
    border-radius: 4px !important;
    box-shadow: rgb(60 64 67 / 30%) 0px 1px 1px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px !important;
    cursor: pointer !important;
    height: 40px !important;
    min-height: 40px !important;
    padding: 12px 24px 10px !important;
    width: 100% !important;
  }
</style>